import React, {useCallback} from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import {CBCButton, getFieldValue, Icon} from 'shared/helpers';
import {isDeviceSmall} from 'shared/helpers/DeviceSize';
import {OverlayTrigger} from 'shared/components/OverlayTrigger';
import {useDrillings} from 'hooks/Product/Drillings';
import {GenericFields} from 'components/customer/Product/Specs/GenericFields';
import {useFormikContext} from 'formik';
import {useProductContext} from 'contexts';

export const Drillings = ({fields, fieldset}) => {
    const isSmallDevice = isDeviceSmall();
    const {values} = useFormikContext();
    const {addDrillingSet, updateDrillingSet, drillingFieldsets, fieldHandler} =
        useDrillings(fields, fieldset);
    const {isMiniBrowser} = useProductContext();

    const updateDrillingSetHandler = useCallback(
        (index, deleteDrilling) => () => {
            updateDrillingSet(index, deleteDrilling);
        },
        [updateDrillingSet]
    );

    const changeHandler = useCallback(
        (index) => (name, value) => {
            fieldHandler(name, value, index);
        },
        [fieldHandler]
    );

    return (
        <Row>
            <Col className="drillings-content">
                {drillingFieldsets.length ? (
                    drillingFieldsets.map((drilling, index) => {
                        const indexedValue = values.drillings
                            ? values.drillings[Number(index)]
                            : {};

                        return (
                            <React.Fragment key={Number(index)}>
                                <Row>
                                    <Col
                                        className="shelf"
                                        md={isMiniBrowser ? 4 : 5}>
                                        <section
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}>
                                            <strong>
                                                {getFieldValue(drilling.title, {
                                                    fieldSet: {index: index},
                                                })}
                                            </strong>
                                            <div className="shelf-actions">
                                                <OverlayTrigger
                                                    placement={
                                                        isSmallDevice
                                                            ? 'top'
                                                            : 'right'
                                                    }
                                                    overlay="Copy hole set">
                                                    <Button
                                                        tabIndex="-1"
                                                        variant="link"
                                                        onClick={updateDrillingSetHandler(
                                                            index
                                                        )}>
                                                        <Icon iconName="Options-Copy.svg" />
                                                    </Button>
                                                </OverlayTrigger>

                                                <OverlayTrigger
                                                    placement={
                                                        isSmallDevice
                                                            ? 'top'
                                                            : 'right'
                                                    }
                                                    overlay="Delete hole set">
                                                    <Button
                                                        tabIndex="-1"
                                                        variant="link"
                                                        onClick={updateDrillingSetHandler(
                                                            index,
                                                            true
                                                        )}>
                                                        <Icon iconName="Options-Delete.svg" />
                                                    </Button>
                                                </OverlayTrigger>
                                            </div>
                                        </section>
                                    </Col>
                                    <Col>
                                        <GenericFields
                                            fields={drilling.fields}
                                            fieldsetName={drilling.name}
                                            fieldsetTitle={drilling.title}
                                            indexedValues={indexedValue}
                                            selectHandler={changeHandler(index)}
                                        />
                                    </Col>
                                </Row>

                                <hr />
                            </React.Fragment>
                        );
                    })
                ) : (
                    <>
                        <strong className="no-drillings">
                            {fieldset.hasOwnProperty('options') &&
                                fieldset.options.hasOwnProperty('emptyText') &&
                                fieldset.options.emptyText}
                        </strong>
                        <br />
                    </>
                )}

                <CBCButton
                    onClick={addDrillingSet}
                    iconName="Button-Add-Shelf.svg"
                    className="btn button-blue short-button">
                    Add Shelf Hole Set
                </CBCButton>
            </Col>
        </Row>
    );
};
